<title></title>
<app-top-navigation></app-top-navigation>

<div *ngIf="isMobileOrTablet" class="block-overlay">
  <div class="block-message">
    <h2>Not Supported</h2>
    <p>This application is only accessible from a Desktop or Laptop.</p>
  </div>
</div>

<ng-container *ngIf="!isMobileOrTablet">

  <mat-menu #userIconMenu="matMenu">
    <div class="row usermenu">
      <div class="border-bottom" (click)="logmethod()" (keydown.enter)="logmethod()">
        <a>
          <fa-icon class="userDetailsIcon" [icon]="HomeIcon" size="lg">
          </fa-icon>&nbsp;-&nbsp;History
        </a>
      </div>
      <div class="border-bottom">
        <a>
          <fa-icon class="userDetailsIcon" [icon]="SquareEnvelopeIcon" size="lg">
          </fa-icon>&nbsp;-&nbsp;Notification
        </a>
      </div>
      <div class="border-bottom">
        <a>
          <fa-icon class="userDetailsIcon" [icon]="CircleQuestionIcon" size="lg">
          </fa-icon>&nbsp;-&nbsp;Help
        </a>
      </div>
    </div>
  </mat-menu>

  <mat-menu #userIconMenu="matMenu">
    <div class="row usermenu">
      <div class="border-bottom"><fa-icon class="userDetailsIcon" [icon]="HomeIcon"
          size="lg"></fa-icon>&nbsp;-&nbsp;Home
      </div>
      <div class="border-bottom"><fa-icon class="userDetailsIcon" [icon]="SquareEnvelopeIcon"
          size="lg"></fa-icon>&nbsp;-&nbsp;Notification</div>
      <div class="border-bottom"><fa-icon class="userDetailsIcon" [icon]="CircleQuestionIcon"
          size="lg"></fa-icon>&nbsp;-&nbsp;Help</div>
      <div class="border-bottom"><fa-icon class="userDetailsIcon" [icon]="SignOutIcon"
          size="lg"></fa-icon>&nbsp;-&nbsp;Logout</div>
    </div>
  </mat-menu>

  <div class="admin-layout" [ngStyle]="{'grid-template-columns':showLeftNav?'15% 85%':'4% 96%'}"
    (click)="closesnackbar()" (keydown.enter)="closesnackbar()">
    <div class="left-nav">
      <div class="tree" [ngStyle]="{'margin-top': showLeftNav ? '15%':'20%'}">
        <app-left-tree></app-left-tree>
      </div>
    </div>
    <!-- for content -->
    <div class="content" (click)="closesnackbar()" (keydown.enter)="closesnackbar()">
      <div class="content-outlet" style="margin-top: 70px;">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #logoutPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelLogoutPopupFunction()" mat-button><i
      style="font-size: 23px;color: gold;" class="fa">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }} </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="logoutAlert-container">
    <span style="font-size: medium;"> Please confirm if you want to logout! </span>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="triggerLogout()">
      <i class="fas fa-sign-out-alt"></i> Logout
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelLogoutPopupFunction()">
      <i class="fas fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #uploadImagesPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelUploadLogoFunction()" mat-button><i
      style="font-size: 23px;color: gold;" class="fa">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }} </label>
    <label for="app-name" class="popupAppTitle">ONE-<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 10px 10px;">
    <div class="row">
      <div class="col-md-12" id="upload-btn-wrapper">
        <button class="btn">Choose image...</button>
        <input id="uploadInputValue" type="file" name="myfile" (change)="uploadImages($event)" />

        <div class="upload-val-container">
          <span id="logo-success-icon" class="far fa-check-circle"></span><span id="logo-success-msg">Image uploaded
            successfully</span>
          <span id="logo-error-icon" class="fas fa-exclamation-circle"></span><span id="logo-error-msg">Please upload
            JPG/JPEG or PNG images only</span>
          <span id="logo-required-icon" class="fas fa-exclamation-circle"></span><span id="logo-required-msg">Please
            upload the image</span>
        </div>

      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="uploadButton" (click)="uploadLogoImage()">
      <i class="fas fa-upload"></i> Upload
    </button>
  </div>
</ng-template>

<ng-template #messageHistoryPopup>
  <button class="close close-button" (click)="cancelMessageHistoryFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="messageTable">
    <table>
      <th> <span>Time</span></th>
      <th> <span>PageName</span></th>
      <th> <span>Message</span></th>
      <th id="menu" class="sticky-col first-col"></th>
      <tr class="data-row-container" *ngIf="SVC.message.length == 0">
        <td colspan="3" class="grid-message-container"> No data to display </td>
      </tr>
      <tr class="data-row-container border-bottom" *ngFor="let list of SVC.message">
        <td style="width:150px" class="btn-align">{{ list.dateTime }}</td>
        <td style="width:150px" class="btn-align">{{ list.pageName }}</td>
        <td [ngStyle]=" {'background-color': (list.type=='Error' ? 'red':'green')}" class="row-data fontcolor">{{
          list.message }}</td>
      </tr>
    </table>
  </div>
</ng-template>

<ng-template #topicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" mat-button (click)="canceltopicPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Topics </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <app-oneqms-topics [topicData]=""></app-oneqms-topics>
</ng-template>